// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1YnvF","disabled":"FileBtn_disabled__2T66W","warn":"FileBtn_warn__pa-88","fade":"FileBtn_fade__3V5Yx"};